import React, { useCallback } from 'react';

import { payloadDownloadFilename, serializePayload } from '~/utils/societePayloadBuilder/statusCampaign/buildPayload';
import type { StatusCampaignPayloadBuilderState } from '~/utils/societePayloadBuilder/statusCampaign/types';

import PayloadBuilderJsonActions from '../JsonActions';

interface StatusCampaignPayloadActionsProps {
  state: StatusCampaignPayloadBuilderState;
  isValid: boolean;
  fullWidth?: boolean;
}

export default function StatusCampaignPayloadActions({ state, isValid, fullWidth = false }: StatusCampaignPayloadActionsProps) {
  const isCampaignPayloadValid = useCallback(() => isValid, [isValid]);

  return (
    <PayloadBuilderJsonActions
      state={state}
      fullWidth={fullWidth}
      isValid={isCampaignPayloadValid}
      serialize={serializePayload}
      getFilename={payloadDownloadFilename}
      disabledTitle="Fix validation errors before copying or downloading"
      copyLabel="Copy to clipboard"
      copySuccessMessage="Payload copied to clipboard"
      copyErrorMessage="Failed to copy payload"
    />
  );
}
